import { COLORS } from '@helpers/constant';
import { Role } from '@interfaces/models';

export const ROLE_COLORS = {
  [Role.CUSTOMER_SUPPORT_ROLE]: COLORS.AMBER,
  [Role.ADMINISTRATOR_ROLE]: COLORS.BLUE,
  [Role.OPERATOR_ROLE]: COLORS.GREEN,
  [Role.OWNER_ROLE]: COLORS.PURPLE,
  [Role.NO_ROLE]: 'default',
} as const;

export const getRoleColor = (role: undefined | Role | null) => {
  if (!role) return 'default';
  return ROLE_COLORS[role] || 'default';
};
